export default {
  cancel: "Cancel",
  category: "Category",
  categories: "Categories",
  date: "Date",
  Inventory: "Inventory",
  name: "Name",
  newCategories: "New Categories",
  newItem: "New Item",
  newUnits: "New Units",
  quantity: "Quantity",
  save: "Save",
  search: "Search",
  sku: "SKU",
  subtotal: "Subtotal",
  unit: "Unit",
  units: "Units",
  unitValue: "Unit Value",
  editItem: "Edit Item"
};
